import React, { useEffect, useRef, useState } from "react";

export default function AudioTracks({ voiceDemos, currentTrackIndex, handleClick }) {
  const containerRef = useRef(null);
  const listRef = useRef(null);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    if (containerRef.current && listRef.current) {
      const containerHeight = containerRef.current.clientHeight;
      const listHeight = listRef.current.scrollHeight;

      // Trigger scroll when content is at least 90% of container height
      if (listHeight >= containerHeight * 0.9) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    }
  }, [voiceDemos]); // recheck whenever list changes

  return (
    <div
      ref={containerRef}
      className={`audio-tracks-container ${showScroll ? "show-scroll" : ""}`}
    >
      <ul ref={listRef} className="demo-list mb-4">
        {voiceDemos.map((demo, index) => (
          <li
            key={demo.id}
            className={`demo-item ${index === currentTrackIndex ? "active" : ""}`}
            onClick={() => handleClick(index)}
          >
            {demo.title}
          </li>
        ))}
      </ul>
    </div>
  );
}
